"use client";

import Link from "next/link";
import { useContext } from "react";
import { AppContext } from "@/context/AppContext";

export default function Footer() {
  const { activePage, isOnCvSubdomain } = useContext(AppContext);
  const currentYear = new Date().getFullYear();

  // Diese Funktion fügt die Domain hinzu, wenn wir auf der CV-Subdomain sind
  const getHref = (path: string): string => {
    if (isOnCvSubdomain) {
      return `https://robinwichmann.com${path}`;
    }
    return path;
  };

  return (
    <div className={`wrapper wrapper--bottom ${activePage}-page`}>
      <footer className="navigation">
        <div className="navigation--frame">
          <div className="navigation--container">
            <nav className="flex items-center justify-between w-full px-4">
              <div className="text-white/60 text-sm mr-4">
                © {currentYear} Robin Wichmann
              </div>
              <div className="flex gap-2">
                <Link
                  href={getHref("/imprint")}
                  className={`footer--link no-select text-sm ${activePage === 'imprint' ? 'router-link-active' : ''}`}
                  style={activePage === 'imprint' ? { color: '#a2fad8' } : {}}
                >
                  Impressum
                </Link>
                <Link
                  href={getHref("/privacy")}
                  className={`footer--link no-select text-sm ${activePage === 'privacy' ? 'router-link-active' : ''}`}
                  style={activePage === 'privacy' ? { color: '#afcf66' } : {}}
                >
                  Datenschutz
                </Link>
              </div>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
} 